import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Paginator } from 'src/app/entidades/paginator';
import { AppConfigService } from 'src/app/services/app/app-config.service';
import { PaginatorService } from 'src/app/services/Paginator/Paginator.service';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() length = 0;
  @Input() pageSize: number = 10;
  @Input() pageIndex: number;
  @Input() multiSelecao = false;
  @Input() pageSizeOptionsAdd: number[] = [];
  pageSizeOptions: number[];
  paginator: Paginator;

  constructor(private paginatorService: PaginatorService,
    private appService: AppConfigService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.pageSizeOptionsAdd) {
      this.carregarOptions();
    }
  }

  ngOnInit(): void {
    this.carregarOptions();
    if (this.pageSize === 0 || this.pageSize === undefined)
      this.pageSize = this.appService.itensPorPagina;
  }

  carregarOptions(): void {
    this.pageSizeOptions = [5, 10, 15, 25, 50, 100, 200, 300];
    if (this.pageSizeOptionsAdd) {
      this.pageSizeOptionsAdd.forEach(element => {
        this.pageSizeOptions.push(element);
      });
    }
  }

  getPaginatorData(event: any): void {
    sessionStorage.setItem('_pagina', JSON.stringify(event));
    this.paginatorService.emitirEvento(event);
  }
}
